import type { Recipe } from '@/types';
import { time } from '@/time';

const recipe: Recipe = {
  title: 'Mashed Sweet Potatoes',
  source: 'https://www.seriouseats.com/the-best-mashed-sweet-potatoes-recipe',
  totalTime: time(3),
  servings: 10,
  tags: { type: 'side' },
  ingredients: [
    { name: 'sweet potatoes', quantity: '4', unit: 'lb' },
    { name: 'thyme', quantity: '8', unit: 'sprigs', customUnit: true },
    { name: 'butter', quantity: '6', unit: 'tbsp' },
    { name: 'maple syrup', quantity: '1/4', unit: 'cup' },
    { name: 'kosher salt' },
  ],
  directions: [
    {
      title: 'Wrap & slow roast',
      bullets: [
        "Wrap {sweet potatoes} & {thyme:6 sprigs} in 2 sealed heavy-duty foil pouches",
        "Transfer pouches to rimmed baking sheet",
        "Bake at {!300F} on middle rack 1h30–1h45, until thin skewer meets some resistance",
      ],
    },
    {
      title: 'Caramelize',
      bullets: [
        "Carefully unwrap & discard foil & thyme sprigs",
        "Place unwrapped potatoes in even layer on sheet pan",
        "Increase oven temperature to {!400F}",
        "Roast 30 min until caramelized & skewer meets no resistance",
        "Remove from oven & cool 20 min",
      ],
    },
    {
      title: 'Brown butter',
      bullets: [
        "In medium saucepan over medium-low heat, melt {butter}, swirling gently, ~10 min until particles are pale golden brown & smell nutty",
        "Transfer to large bowl",
        "Add {maple syrup}",
        "Pick leaves off remaining {thyme:2 sprigs}, roughly chop & add to bowl",
      ],
    },
    {
      title: 'Mash',
      bullets: [
        "Peel cooled potatoes, discarding skins & juices",
        "Add flesh to bowl with butter mixture",
        "Beat on medium-low ~2 min until smooth & fluffy",
        "Season to taste with {kosher salt}"
      ],
    },
  ],
};

export default recipe;
